import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate
} from '../../../../Utils';
import Hosts, { companycode } from '../../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)
	const [files_image, set_files_image] = useState([]);
	const [, set_image_base64] = useState([])
	const [img_loader, set_img_loader] = useState([])
	const [selectedUnit, setSelectedUnit] = useState(String(dados?.current?.info?.unidade || '').trim());
	const [selectedIVA, setSelectedIVA] = useState(String(dados?.current?.info?.unidade || '').trim());
	const [ivaOptions, setIVAOptions] = useState([]);

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
			})
			.catch(error => console.log(error));
	};

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const uploadFilesImage = async (files, order, type, langid, lang) => {
		let aux = []
		return await files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				return await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', getTokenInfo().companycode)
		formData.append('uniqid', '')
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then(async (res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				dados.current.info.image = {
					id: i,
					url: res.data.path + '/' + res.data.name,
					link: res.data.path + '/' + res.data.name,
					type: res.data.mimetype,
					size: res.data.size,
					date: today_file
				}

				await reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 

						reqPOST(`${api_crud_base}/multimedia`, x)
							.then(() => {

								let y2 = img_loader
								y2.pop()
								set_img_loader(y2)
								setRefresh(i)

							})
							.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}


	useEffect(() => {
		const initialize = async () => {
			clean_data();
			set_lang(localStorage.getItem('lang'));

			try {
				const operation = props?.location?.state?.operation;
				const item = props?.location?.state?.item;

				const res_8 = await reqGET(`${api_crud_base}/intranet/org/codivas`);
				setIVAOptions(res_8?.data || []);
				console.log('ivaOptions', res_8?.data);

				if (operation === 'edit') {
					set_is_edit(true);
					set_show_delete_button(true);
					set_image_base64([]);

					await fetch_id_info(item?.id);
					console.log('dados.current', dados.current);
				} else {
					const nextOrder = parseInt(item?.order || '0', 10) + 1;
					dados.current.info.order = nextOrder;
					set_dados(dados.current.info);
				}
			} catch (err) {
				console.error('Initialization error:', err);
				clean_data();
				setRedirect(false);
			} finally {
				setLoading(false);
			}
		};

		initialize();

		// Cleanup on unmount
		return () => {
			clean_data();
		};

	}, [props]);


	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {

						files_image.forEach(async (el_image) => {
							if (el_image !== null) {
								if (el_image.files.length > 0) {
									await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
								}
							}
						})
						set_files_image([])
						set_image_base64([])


						console.log('dados.current', dados.current)

						reqPUT(api_crud_route, dados.current)
							.then(() => {
								//props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						files_image.forEach(async (el_image) => {
							if (el_image !== null) {
								if (el_image.files.length > 0) {
									await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
								}
							}
						})
						set_files_image([])
						set_image_base64([])

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}


		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		dados.current.info[name] = value
	}

	const handle_change_iva = (e) => {
		const selectedNome = e.target.value;
		const selectedIVA = ivaOptions.find((item) => item.nome === selectedNome);

		if (selectedIVA) {
			dados.current.info.iva = selectedIVA;
			set_dados({ ...dados.current.info });
		} else {
			dados.current.info.iva = null;
			set_dados({ ...dados.current.info });
		}
	};

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if (aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if (el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if (name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		// console.log('«««««««««««««««««««««««')
		// console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	useEffect(() => {
		if (dados?.current?.info?.unidade) {
			setSelectedUnit(String(dados.current.info.unidade).trim());
		}
		if (dados?.current?.info?.taxa_iva) {
			setSelectedIVA(String(dados.current.info.taxa_iva).trim());
		}
	}, [dados?.current?.info?.unidade, dados?.current?.info?.taxa_iva]);


	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">

							<div className="mb-5 mb-xl-10">
								<div className='card'>

									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
														:
														null
												}
											</ul>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
														content_language.length > 0 ?
															content_language.map((el_lang, k_lang) => {
																return (
																	<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																		<div className="row mb-3">
																			<div className="col-md-5">
																				<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																				<input
																					type="text"
																					name="title"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={translate(dados.current.info.title, el_lang.code)}
																					onChange={(e) => handle_change_info_translate(e)}
																					className="form-control rounded-0"
																					required={el_lang.id === '1' ? 'required' : ''} />
																			</div>

																			<div className="col-md-4">
																				<label className="fs-6 fw-bold mb-2">
																					{language[lang].field_unidade}
																				</label>
																				<select
																					name="unidade"
																					className="form-select form-control mb-4 mb-lg-0 rounded-0"
																					onChange={(e) => {
																						setSelectedUnit(e.target.value);
																						dados.current.info.unidade = e.target.value;
																						handle_change_info(e);
																					}}
																					value={selectedUnit}
																				>
																					<option value="">{language[lang].field_choose}</option>
																					<option value="A">{language[lang].unit_A}</option>
																					<option value="cm">{language[lang].unit_cm}</option>
																					<option value="cx">{language[lang].unit_cx}</option>
																					<option value="gal">{language[lang].unit_gal}</option>
																					<option value="g">{language[lang].unit_g}</option>
																					<option value="kg">{language[lang].unit_kg}</option>
																					<option value="kWh">{language[lang].unit_kWh}</option>
																					<option value="kWp">{language[lang].unit_kWp}</option>
																					<option value="L">{language[lang].unit_L}</option>
																					<option value="m">{language[lang].unit_m}</option>
																					<option value="m²">{language[lang].unit_m2}</option>
																					<option value="m³">{language[lang].unit_m3}</option>
																					<option value="mg">{language[lang].unit_mg}</option>
																					<option value="mm">{language[lang].unit_mm}</option>
																					<option value="mL">{language[lang].unit_mL}</option>
																					<option value="par">{language[lang].unit_par}</option>
																					<option value="pc">{language[lang].unit_pc}</option>
																					<option value="pct">{language[lang].unit_pct}</option>
																					<option value="t">{language[lang].unit_t}</option>
																					<option value="un">{language[lang].unit_un}</option>
																					<option value="V">{language[lang].unit_V}</option>
																					<option value="W">{language[lang].unit_W}</option>
																				</select>
																			</div>

																			{
																				el_lang.id === '1' || true ?
																					<div className="col-2">
																						<div className="d-flex">
																							<div className="mb-3 d-none">
																								<label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
																								<div className="input-group">
																									<label className="switch">
																										<input
																											id={'item-switch-active'}
																											name={"active"}
																											className=""
																											type="checkbox"
																											value={dados.current.info.active}
																											onChange={handleSingleCheckActive}
																											defaultChecked={dados.current.info.active}
																										/>
																										<span className="slider" htmlFor={'item-switch-active'}></span>
																									</label>
																								</div>
																							</div>

																							<div className="ms-3 mb-3">
																								<label className="fs-6 fw-bold mb-2">{language[lang].field_avaiable}</label>
																								<div className="input-group">
																									<label className="switch">
																										<input
																											id={'item-switch-avaiable'}
																											name={"avaiable"}
																											className=""
																											type="checkbox"
																											value={dados.current.info.avaiable}
																											onChange={handleSingleCheckAvaiable}
																											defaultChecked={dados.current.info.avaiable}
																										/>
																										<span className="slider" htmlFor={'item-switch-avaiable'}></span>
																									</label>
																								</div>
																							</div>
																						</div>
																					</div>
																					:
																					null
																			}
																		</div>
																		<div className="row mb-3">
																			<div className="col-md-4 d-none">
																				<label className="fs-6 fw-bold mb-2">
																					{language[lang].field_taxa_iva}
																				</label>
																				<select
																					name="taxa_iva"
																					className="form-select form-control mb-4 mb-lg-0 rounded-0"
																					onChange={(e) => {
																						setSelectedIVA(e.target.value);
																						dados.current.info.taxa_iva = e.target.value;
																						handle_change_info(e);
																					}}
																					value={selectedIVA}
																				>
																					<option value="">{language[lang].field_choose}</option>
																					<option value="0.23">{language[lang].taxa_normal_continente}</option>
																					<option value="0.22">{language[lang].taxa_normal_madeira}</option>
																					<option value="0.16">{language[lang].taxa_normal_acores}</option>
																					<option value="0.13">{language[lang].taxa_intermedia_continente}</option>
																					<option value="0.12">{language[lang].taxa_intermedia_madeira}</option>
																					<option value="0.09">{language[lang].taxa_intermedia_acores}</option>
																					<option value="0.06">{language[lang].taxa_reduzida_continente}</option>
																					<option value="0.05">{language[lang].taxa_reduzida_madeira}</option>
																					<option value="0.04">{language[lang].taxa_reduzida_acores}</option>
																				</select>
																			</div>

																			<div className="col-md-4">
																				<label className="fs-6 fw-bold mb-2">
																					{language[lang].field_taxa_iva}
																				</label>
																				<select
																					name="taxa_iva"
																					className="form-select form-control mb-4 mb-lg-0 rounded-0"
																					onChange={handle_change_iva}
																					value={dados?.current?.info?.iva?.nome || ''}
																				>
																					<option value="">{language[lang].select_placeholder || 'Selecione uma taxa'}</option>
																					{ivaOptions.map((item) => (
																						<option key={item.id} value={item.nome}>
																							{item.nome}
																						</option>
																					))}
																				</select>

																			</div>

																		</div>
																		<div className="row mb-5 d-none">
																			<div className="col-6">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_subtitle} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																				<input type="text" name="subtitle" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.subtitle, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" />
																			</div>
																		</div>
																	</div>
																)
															})
															:
															null
													}
												</div>
											</div>
										</form>
									</div>

								</div>
							</div>

						</div>
					</div>
				</div >

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
